import React from "react";
import { CardTechnologies } from "./CardTechnologies/CardTechnologies";
import { technologies } from "Developers/EstebanCaccin/constants";

import "./technologies.scss";
export const Technologies = () => {
  return (
    <div className='container technologies'>
      <div className='container-cards-technologies'>
        <h2 className='title'>Tecnologías</h2>
        <div className='d-flex justify-content-center flex-wrap'>
          {technologies.map((e, i) => (
            <CardTechnologies {...e} key={i} />
          ))}
        </div>
      </div>
    </div>
  );
};
